/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_RECORDS_META_DATA,
  LOAD_ORGANIZATION,
  LOAD_BUSINESS_META_DATA,
  LOAD_USER_ROLE,
  LOAD_USERS,
  LOAD_USER_ACTIVITIES,
} from "./constants";

import {
  loadOrganizationListError,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadOrganizationList,
  loadOrganizationListSuccess,
  loadBusinessMetaDataSuccess,
  loadBusinessMetaDataError,
  loadUserRole,
  loadUserRoleSuccess,
  loadUserRoleError,
  loadTokenExpiry,
  loadTokenExpirySuccess,
  loadTokenExpiryError,
  loadUsers,
  loadUsersSuccess,
  loadUsersError,
  loadActivities,
  loadActivitiesSuccess,
  loadActivitiesError,
} from "./actions";

import {
  loadRecordsMetaData,
  loadOrganizationDetails,
  loadBusinessMetaDataDetails,
  loadUserRoleDetails,
  loadTokenExpiryDetails,
  loadUsersDetails,
  loadActivitiesDetails,
} from "./remotes";

function* loadOrganizationListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ORGANIZATION),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadOrganizationList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadOrganizationDetails, searchFilter);
        if (result) {
          yield put(loadOrganizationListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadOrganizationListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadUserRoleSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USER_ROLE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadUserRole(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadUserRoleDetails, searchFilter);
        if (result) {
          yield put(loadUserRoleSuccess(result));
        }
      } catch (error) {
        yield put(
          loadUserRoleError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadUsersSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USERS),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadUsers(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadUsersDetails, searchFilter);
        if (result) {
          yield put(loadUsersSuccess(result));
        }
      } catch (error) {
        yield put(
          loadUsersError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTokenExpirySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USER_ROLE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadTokenExpiry(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTokenExpiryDetails, searchFilter);
        if (result) {
          yield put(loadTokenExpirySuccess(result));
        }
      } catch (error) {
        yield put(
          loadTokenExpiryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadUserActivitiesSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_USER_ACTIVITIES),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadActivities(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadActivitiesDetails, searchFilter);
        if (result) {
          yield put(loadActivitiesSuccess(result));
        }
      } catch (error) {
        yield put(
          loadActivitiesError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    });

    try {
      const country = yield call(loadRecordsMetaData, "getcountry", "post");
      const state = yield call(loadRecordsMetaData, "getstate", "post");
      const language = yield call(loadRecordsMetaData, "getlang", "post");
      const gstType = yield call(loadRecordsMetaData, "getgsttype", "post");
      const category = yield call(loadRecordsMetaData, "getorgcate", "post");
      const plan = yield call(loadRecordsMetaData, "getplan", "post");
      const size = yield call(loadRecordsMetaData, "getsize", "post");

      let recordsMetaData = {
        countryOptions:
          (country &&
            country &&
            country.length > 0 &&
            country.map((c) =>
              Object.assign(
                {},
                {
                  label: c.countryName,
                  value: c._id,
                }
              )
            )) ||
          [],
        stateOptions:
          (state &&
            state &&
            state.length > 0 &&
            state.map((c) =>
              Object.assign(
                {},
                {
                  label: c.stateName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        languageOptions:
          (language &&
            language &&
            language.length > 0 &&
            language.map((c) =>
              Object.assign(
                {},
                {
                  label: c.languageName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        gstTypeOptions:
          (gstType &&
            gstType &&
            gstType.length > 0 &&
            gstType.map((c) =>
              Object.assign(
                {},
                {
                  label: c.gstName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        categoryOptions:
          (category &&
            category &&
            category.length > 0 &&
            category.map((c) =>
              Object.assign(
                {},
                {
                  label: c.categoryName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        planOptions:
          (plan &&
            plan &&
            plan.length > 0 &&
            plan.map((c) =>
              Object.assign(
                {},
                {
                  label: c.planName,
                  description: c.description,
                  value: c._id,
                }
              )
            )) ||
          [],
        sizeOptions:
          (size &&
            size &&
            size.length > 0 &&
            size.map((c) =>
              Object.assign(
                {},
                {
                  label: c.sizeName,
                  description: c.description,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

function* loadBusinessMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_BUSINESS_META_DATA),
    });

    try {
      const country = yield call(
        loadBusinessMetaDataDetails,
        "getcountry",
        "post"
      );
      const state = yield call(loadBusinessMetaDataDetails, "getstate", "post");
      const businessType = yield call(
        loadBusinessMetaDataDetails,
        "gettype",
        "post"
      );

      let recordsMetaData = {
        countryOptions:
          (country &&
            country &&
            country.length > 0 &&
            country.map((c) =>
              Object.assign(
                {},
                {
                  label: c.countryName,
                  value: c._id,
                }
              )
            )) ||
          [],
        stateOptions:
          (state &&
            state &&
            state.length > 0 &&
            state.map((c) =>
              Object.assign(
                {},
                {
                  label: c.stateName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
        businessTypeOptions:
          (businessType &&
            businessType &&
            businessType.length > 0 &&
            businessType.map((c) =>
              Object.assign(
                {},
                {
                  label: c.regName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadBusinessMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadBusinessMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadOrganizationListSaga(),
    loadBusinessMetaDataSaga(),
    loadUserActivitiesSaga(),
    loadRecordsMetaDataSaga(),
    loadUserRoleSaga(),
    loadTokenExpirySaga(),
    loadUsersSaga(),
  ]);
}
